import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SupplierNegotiations from '../components/SupplierNegotiations';

export default function SupplierNegotiationsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 py-6">
        <Link to="/supplier-dashboard" className="inline-flex items-center text-sm text-muted-foreground hover:text-navy mb-4" data-testid="back-to-supplier-dashboard">
          <ArrowLeft className="h-4 w-4 mr-1.5" /> Back to Supplier Dashboard
        </Link>
        <SupplierNegotiations />
      </div>
    </div>
  );
}
